import {
    actionCreator,
    checkHttpStatus,
    NoteActionTypes,
    jsonApiHeader,
    showSuccessMessage,
    showWarningMessage,
    showErrorMessage,
    GET_NOTE_TYPES_LIST_API,
    DELETE_NOTE_TYPE_API,
    POST_NOTE_TYPE_API,
    GET_NOTE_TYPE_DETAILS_API ,
  } from '../constants/ApiConstants';
  import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';
  
  export const getNoteTypeList = (searchObj) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(NoteActionTypes.get_noteTypesList.REQUEST));
      let query_params = createSearchUrlForCustomAPI(searchObj);
      fetch(`${GET_NOTE_TYPES_LIST_API}${query_params}`, {
        method: 'GET',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            dispatch(actionCreator(NoteActionTypes.get_noteTypesList.SUCCESS, response));
          } else {
            dispatch(actionCreator(NoteActionTypes.get_noteTypesList.SUCCESS, null));
          }
        })
        .catch(function(error) {
          console.log('error get_noteTypesList', error);
        });
    };
  };
  
  export const saveNoteTypes = (formData) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(NoteActionTypes.post_noteType.REQUEST));
      fetch(POST_NOTE_TYPE_API, {
        method: 'POST',
        body: JSON.stringify(formData),
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(NoteActionTypes.post_noteType.SUCCESS, response));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(NoteActionTypes.post_noteType.SUCCESS, null));
          }
        })
        .catch(function(error) {
          console.log('error post_noteType', error);
        });
    };
  };
  
  export const getNoteTypeDetails = (insuranceTypeId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(NoteActionTypes.get_noteTypeDetails.REQUEST));
      fetch(`${GET_NOTE_TYPE_DETAILS_API}/${insuranceTypeId}`, {
        method: 'GET',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            dispatch(actionCreator(NoteActionTypes.get_noteTypeDetails.SUCCESS, response));
          } else {
            dispatch(actionCreator(NoteActionTypes.get_noteTypeDetails.SUCCESS, null));
          }
        })
        .catch(function(error) {
          console.log('error get_noteTypeDetails', error);
        });
    };
  };
  
  export const deleteNoteType = (Id) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(NoteActionTypes.delete_noteType.REQUEST));
      fetch(`${DELETE_NOTE_TYPE_API}/${Id}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode === 200 || response.statusCode === 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(NoteActionTypes.delete_noteType.SUCCESS, response));
          } else if (response.statusCode === 401 || response.statusCode === 422) {
            showWarningMessage(response.message);
            dispatch(actionCreator(NoteActionTypes.delete_noteType.SUCCESS, null));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(NoteActionTypes.delete_noteType.SUCCESS, null));
          }
        })
        .catch(function(error) {
          console.log('error delete_noteType', error);
        });
    };
  };
  
  


// WEBPACK FOOTER //
// ./src/modules/Masters/components/note-master/actions/NoteActions.js